module.exports = __webpack_public_path__ + "static/logos-14-8be6a6c1985199f78b67206e89ae3dfb.png";